module.exports = __webpack_public_path__ + "img/shoes_item.2f7406bf.png";